import PriceItemList, { PriceItemListProps } from './PriceItemList';

export type { PriceItemListProps };
export default PriceItemList;
